import { MotifCard, MotifCardBody, MotifModal, MotifModalHeader } from '@ey-xd/motif-react';
import React from 'react'
import Button from '@ey-xd/motif-react/components/button';
import ViewQuestionnaireContainer from './ViewQuestionnaireContainer';

const ViewQuostionnaireDialog = (props: any) => {
  const { content, enabledToAnswer, requestParams, updateContent } = props;
  
  const [open, setOpen] = React.useState(false);
  const { title, ...rest } = content;

  return (
    <div>
      <MotifCard>
        <MotifCardBody>
          <Button variant="text-alt" onClick={() => setOpen(!open)}>Open questionnaire dialog</Button>
        </MotifCardBody>
      </MotifCard>
      <MotifModal
        onClose={() => setOpen(!open)}
        show={open}
        size={"xl"}

      >
        <MotifModalHeader
        >
          <span>
            {title}
          </span>
        </MotifModalHeader>
        <ViewQuestionnaireContainer {...rest} closeHandler={() => setOpen(!open)} updateContent={updateContent} requestParams={requestParams} />
      </MotifModal>
    </div>
  )
}

export default ViewQuostionnaireDialog